import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { ISKULevelPlanningPayload } from '../interfaces/sku-level-rolling-plan.interface';
import { getRequest, HandlerResponse, postFileUploadRequest, postRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetSKULevelRollingPlanData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/skuRollingPlan/getSKUGridData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const InitializeSKU = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/skuRollingPlan/initialiseSKU${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlan = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/skuRollingPlan/freezePlan${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateData = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/skuRollingPlan/savePHData${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const CopyAspToPlan = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/skuRollingPlan/data/copyAsp${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplate = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/sku/upload${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetSKULevelRollingPlanEditAllData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/skuRollingPlan/getSKUGridData/week${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const SaveSKULevelWeekData = async (payload: {rows: any[]}, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/skuRollingPlan/save/weekEdit${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};
